import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { MoneyFieldProps } from "./MoneyField.types";

function getCurrencySymbol(currency: string): string {
  const part = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  })
    .formatToParts(0)
    .find((p) => p.type === "currency");

  return part ? part.value : currency;
}

/** Money editable field - shows the currency symbol as an input-group prefix. */
export function MoneyField({
  label,
  name,
  value,
  onChange,
  currency = "GBP",
  disabled,
  required,
  error,
  className,
  placeholder,
  helpText,
}: MoneyFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} required={required} helpText={helpText} error={error} className={className}>
      <div className="input-group">
        <span className="input-group-text">{getCurrencySymbol(currency)}</span>
        <input
          id={name}
          aria-describedby={fieldDescribedBy(name, helpText, error)}
          aria-invalid={error ? true : undefined}
          name={name}
          type="number"
          step="0.01"
          className={fieldControlClass("form-control", error)}
          value={value ?? ""}
          onChange={(event) =>
            onChange(event.target.value === "" ? null : Number(event.target.value))
          }
          placeholder={placeholder}
          disabled={disabled}
          required={required}
        />
      </div>
    </FieldValue>
  );
}
